import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DealActions from '../../redux/actions';
import { useParams } from 'react-router-dom';
import { RootState } from '../../../../../store/rootReducer';
import { Spin } from 'antd';

const TermSheetComp: React.FC = () => {
    let uuid = useParams().uuid;
    const dispatch = useDispatch();
    const deal = useSelector((state: RootState) => state.deal);
    const tsLoading = useSelector((state: RootState) => state.deal.tsLoading);

    React.useEffect(() => {
        if (uuid) {
            dispatch(DealActions.getTermSheetReq(uuid))
        }
    }, [dispatch, uuid])

    return (
        <>
            {!tsLoading ? <div id='term_sheet' className='p-8'>
                {deal.termSheetData ?
                    <iframe title='term-sheet' src={`${deal.termSheetData}`} allow="fullscreen"></iframe>
                    :
                    <div className='text-center text-xl font-bold'> No Data</div>
                }
            </div> : <div>
                <div className="p-8 flex justify-center items-center h-full">
                    <Spin size="large" />
                </div>
            </div>}
        </>
    );
};

export default TermSheetComp;
